import { render } from "./ContactSupportComponent.vue?vue&type=template&id=006eb108&scoped=true"
import script from "./ContactSupportComponent.vue?vue&type=script&lang=js"
export * from "./ContactSupportComponent.vue?vue&type=script&lang=js"

import "./ContactSupportComponent.vue?vue&type=style&index=0&id=006eb108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006eb108"]])

export default __exports__